<div class="row">
	<div class="col-12">
		<div class="content-header">Main menu Form</div>
	</div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
	<div class="row">
		<div class="col-12">
			<div class="card">

				<div class="card-content">
					<div class="card-body">
						<div class="row">
							<div class="col-md">
								<form [formGroup]="mainMenuForm">
									<fieldset class="form-group">
										<label for="title">Title<span class="required_field">*</span></label>
										<input type="text" class="form-control" formControlName="title"
											[(ngModel)]="mainMenuModel.title" id="title" placeholder="Enter title" 
											#title required >
										<div *ngIf="!rf.title.valid && (rf.title.dirty || rf.title.touched)" class="help-block mt-1 text-danger"> <i class="ft-alert-circle
									align-middle"></i> Title is required!
										</div>
									</fieldset>
                                    <fieldset class="form-group">
										<label for="path">Path<span class="required_field">*</span></label>
										<input type="text" class="form-control" formControlName="path"
											[(ngModel)]="mainMenuModel.path" id="path" placeholder="Enter path" 
											#path required >
										<div *ngIf="!rf.path.valid && (rf.path.dirty || rf.path.touched)" class="help-block mt-1 text-danger"> <i class="ft-alert-circle
									align-middle"></i> Path is required!
										</div>
									</fieldset>									
									<fieldset class="mb-3">
										<label>Classes<span class="required_field">*</span></label>
											<ng-select [items]="classes_list" bindLabel="name" placeholder="Select Classes"
												[(ngModel)]="select_class_mainMenu" [ngModelOptions]="{ standalone: true }"
												[closeOnSelect]="false"
												(change)="getClassMainMenuId($event)">
											</ng-select>
									</fieldset>	
								</form>
							</div>
							<div class="col-md">

								<form [formGroup]="mainMenuForm">
									
									<fieldset class="mb-2">
										<label>Sub menu<span class="required_field">*</span></label>
											<ng-select [items]="sub_menu_List" bindLabel="title" [multiple]="true" [closeOnSelect]="false"
												bindValue="_id" placeholder="Select Sub menu" 
												[(ngModel)]="select_sub_menu" [ngModelOptions]="{ standalone: true }" 
												(change)="getSubMenuId($event)">
												<ng-template ng-header-tmp>
													<div class="btn btn-link" (click)="openModal(myModal)">
														Add New Sub Menu
													</div>
												</ng-template>
												<ng-template ng-option-tmp let-item="item">
													<span>{{ item.title }}</span><span>&nbsp;&nbsp;&nbsp;</span>
													<i *ngIf="item.id === selectedItemId && item.job_id" class="fa fa-edit" (click)="editItem(item,myModal2)"></i>&nbsp;&nbsp;
													<i *ngIf="item.id === selectedItemId && item.job_id" class="fa fa-trash" (click)="confirmDelete(item._id)"></i>
												</ng-template>
											</ng-select>
									</fieldset>
									<fieldset class="mb-3">
										<label>Employee Type<span class="required_field">*</span></label>
											<ng-select [items]="typeList" bindLabel="displayname" bindValue="_id" placeholder="Select EmployeeType"
												[(ngModel)]="selectType_mainMenu" [ngModelOptions]="{ standalone: true }" [multiple]="true"
												[closeOnSelect]="false"
												(change)="getTypeMainMenuId($event)">
											</ng-select>
									</fieldset>									
								</form>
							</div>
							<div
							class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
						  >
							<button
							  type="submit"
							  class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
							  (click)="submit()"
							>
							  Submit
							</button>
							<button
							  type="reset"
							  class="btn btn-secondary"
							  (click)="back()"
							>
							  Cancel
							</button>
						  </div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-------------- Add Reference Popup ------------------------------------------->
<div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Add Sub Menu</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form [formGroup]="subMenuForm">
				<div class="form-group">
					<label>Title</label>
					<input type="text" class="form-control" [(ngModel)]="submenu_model.title"  [ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Path</label>
					<input type="text" class="form-control" [(ngModel)]="submenu_model.path"  [ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Classes<span class="required_field">*</span></label>
					<ng-select [items]="classes_list" bindLabel="name" placeholder="Select Classes"
						[(ngModel)]="select_class_subMenu" [ngModelOptions]="{ standalone: true }"
						[closeOnSelect]="false"
						(change)="getClassSubMenuId($event)">
					</ng-select>
				</div>
				<div class="form-group">
					<label>Sub menu<span class="required_field">*</span></label>
					<ng-select [items]="sub_menu_List" bindLabel="title" [multiple]="true"
					bindValue="_id" placeholder="Select Sub menu" 
						[(ngModel)]="select_sub_menu2nd" [ngModelOptions]="{ standalone: true }" 
						(change)="getSubMenuId($event)">
						<ng-template ng-header-tmp>
							<div class="btn btn-link" (click)="openModal2nd(myModal_2nd)">
								Add New Sub Menu
							</div>
						</ng-template>
						<ng-template ng-option-tmp let-item="item">
							<span>{{ item.title }}</span><span>&nbsp;&nbsp;&nbsp;</span>
							<i *ngIf="item.id === selectedItemId && item.job_id" class="fa fa-edit" (click)="editItem(item,myModal2)"></i>&nbsp;&nbsp;
							<i *ngIf="item.id === selectedItemId && item.job_id" class="fa fa-trash" (click)="confirmDelete(item._id)"></i>
						</ng-template>
					</ng-select>
				</div>
				<div class="form-group">
					<label>Employee Type<span class="required_field">*</span></label>
					<ng-select [items]="typeList" bindLabel="displayname" bindValue="_id" placeholder="Select EmployeeType"
						[(ngModel)]="selectType_subMenu" [ngModelOptions]="{ standalone: true }" [multiple]="true"
						[closeOnSelect]="false"
						(change)="getTypeSubMenuId($event)">
					</ng-select>
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="submitSubMenu()">Submit</button>

		  </div>
	</ng-template>
</div>
<div>
	<ng-template #myModal_2nd let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Add Sub Menu</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form [formGroup]="subMenu2ndForm">
				<div class="form-group">
					<label>Title</label>
					<input type="text" class="form-control" [(ngModel)]="submenu_model2nd.title"  [ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Path</label>
					<input type="text" class="form-control" [(ngModel)]="submenu_model2nd.path"  [ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Classes<span class="required_field">*</span></label>
					<ng-select [items]="classes_list" bindLabel="name" placeholder="Select Classes"
						[(ngModel)]="select_class_subMenu3rd" [ngModelOptions]="{ standalone: true }"
						[closeOnSelect]="false"
						(change)="getClassSubMenu3Id($event)">
					</ng-select>
				</div>
				<div class="form-group">
					<label>Sub menu<span class="required_field">*</span></label>
					<ng-select [items]="sub_menu_List" bindLabel="title" [multiple]="true"
					bindValue="_id" placeholder="Select Sub menu" 
						[(ngModel)]="select_sub_menu3rd" [ngModelOptions]="{ standalone: true }" 
						(change)="getSubMenuId2nd($event)">
						<ng-template ng-header-tmp>
							<div class="btn btn-link" (click)="openModal(myModal)">
								Add New Sub Menu
							</div>
						</ng-template>
						<ng-template ng-option-tmp let-item="item">
							<span>{{ item.title }}</span><span>&nbsp;&nbsp;&nbsp;</span>
							<i *ngIf="item.id === selectedItemId && item.job_id" class="fa fa-edit" (click)="editItem(item,myModal2)"></i>&nbsp;&nbsp;
							<i *ngIf="item.id === selectedItemId && item.job_id" class="fa fa-trash" (click)="confirmDelete(item._id)"></i>
						</ng-template>
					</ng-select>
				</div>
				<div class="form-group">
					<label>Employee Type<span class="required_field">*</span></label>
					<ng-select [items]="typeList" bindLabel="displayname" bindValue="_id" placeholder="Select EmployeeType"
						[(ngModel)]="selectType_subMenu2nd" [ngModelOptions]="{ standalone: true }" [multiple]="true"
						[closeOnSelect]="false"
						(change)="getTypeSubMenuId2nd($event)">
					</ng-select>
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="submitSubMenu2nd()">Submit</button>

		  </div>
	</ng-template>
</div>
<!-------------- Edit Reference Popup ------------------------------------------->
<!-- <div>
	<ng-template #myModal2 let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Update Reference</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form [formGroup]="referenceForm">
				<div class="form-group">
					<label>Name</label>
					<input type="text" class="form-control" [(ngModel)]="reference_model.name"  [ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Link</label>
					<input type="text" class="form-control" [(ngModel)]="reference_model.links"  [ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Description</label>
					<textarea class="form-control" [(ngModel)]="reference_model.description"  [ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30"
						rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Notes</label>
					<textarea class="form-control" [(ngModel)]="reference_model.notes"  [ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30"
						rows="2"></textarea>
				</div>
				<div class="form-group">
					<label>Admin Notes</label>
					<textarea class="form-control" [(ngModel)]="reference_model.admin_notes"  [ngModelOptions]="{standalone: true}" name="notes" id="notes" cols="30"
						rows="2"></textarea>
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="updateRef()">Update</button>
		  </div>
	</ng-template>
</div> -->